module.exports = __webpack_public_path__ + "img/main-logo.aabc4e7e.png";